import type { CSSProperties } from 'react'

const paths: Record<string, string> = {
  dashboard: 'M3 3h7v7H3z M14 3h7v7h-7z M3 14h7v7H3z M14 14h7v7h-7z',
  chat: 'M21 11.5a8.5 8.5 0 0 1-8.5 8.5H4l-2 2V11.5A8.5 8.5 0 0 1 10.5 3h2a8.5 8.5 0 0 1 8.5 8.5Z M7 10h10 M7 14h6',
  calendar:
    'M8 2v4 M16 2v4 M3 10h18 M5 4h14a2 2 0 0 1 2 2v14H3V6a2 2 0 0 1 2-2Z M8 14h2 M14 14h2',
  ticket:
    'M3 5h18v5a2 2 0 0 0 0 4v5H3v-5a2 2 0 0 0 0-4Z M15 5v3 M15 11v2 M15 16v3',
  visitors:
    'M12 3v3 M12 18v3 M3 12h3 M18 12h3 M8 12a4 4 0 1 0 8 0 4 4 0 0 0-8 0Z',
  leads:
    'M14 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z M3 21v-2a7 7 0 0 1 12-5 M19 13v8 M15 17h8',
  pipeline: 'M3 4h5v16H3z M10 4h5v11h-5z M17 4h5v7h-5z',
  bot: 'M12 2v3 M5 5h14a2 2 0 0 1 2 2v12H3V7a2 2 0 0 1 2-2Z M7 10v2 M17 10v2 M8 15h8 M1 10v5 M23 10v5',
  book: 'M12 5v16 M12 5C8 2 4 3 2 4v15c4-1 7-1 10 2 3-3 6-3 10-2V4c-4-1-7-1-10 1Z',
  bolt: 'M13 2 3 14h8l-1 8 11-13h-8Z',
  chart: 'M3 3v18h18 M7 16v-5 M12 16V7 M17 16V4',
  plug: 'M8 2v5 M16 2v5 M5 7h14v3a7 7 0 0 1-14 0Z M12 17v5',
  code: 'm8 6-6 6 6 6 M16 6l6 6-6 6 M14 3l-4 18',
  team: 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z M2 21v-3a7 7 0 0 1 14 0v3 M16 3a4 4 0 0 1 0 8 M18 14a5 5 0 0 1 4 5v2',
  card: 'M3 5h18v14H3z M3 9h18 M7 15h3',
  box: 'm12 2 10 5v10l-10 5-10-5V7Z M2 7l10 5 10-5 M12 12v10 M7 4.5l10 5',
  arrow: 'M5 12h14 M13 6l6 6-6 6',
  chevron: 'm9 5 7 7-7 7',
  search: 'M10.5 18a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z M16 16l5 5',
  menu: 'M4 6h16 M4 12h16 M4 18h16',
  sun: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z M12 2v2 M12 20v2 M2 12h2 M20 12h2 M5 5l1 1 M18 18l1 1 M5 19l1-1 M18 6l1-1',
  moon: 'M21 13A9 9 0 0 1 11 3a9 9 0 1 0 10 10Z',
  spark: 'm12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5Z',
  plus: 'M12 5v14 M5 12h14',
  check: 'm5 12 4 4L19 6',
  shield: 'm12 2 9 4v6c0 5-9 10-9 10S3 17 3 12V6Z m-4 10 3 3 5-6',
  logout: 'M9 3H3v18h6 M8 12h13 M16 7l5 5-5 5',
  sliders: 'M4 6h10 M18 6h2 M4 12h4 M12 12h8 M4 18h12 M20 18h0 M14 4v4 M8 10v4 M16 16v4',
}

export function Icon({
  name,
  size = 20,
  style,
}: {
  name: string
  size?: number
  style?: CSSProperties
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={style}
    >
      <path d={paths[name] ?? paths['dashboard']} />
    </svg>
  )
}

export const NAV_ICONS: Record<string, string> = {
  '': 'dashboard',
  '/my-day': 'calendar',
  '/inbox': 'chat',
  '/tickets': 'ticket',
  '/visitors': 'visitors',
  '/leads': 'leads',
  '/pipeline': 'pipeline',
  '/bots': 'bot',
  '/knowledge': 'book',
  '/automations': 'bolt',
  '/analytics': 'chart',
  '/integrations': 'plug',
  '/developers': 'code',
  '/team': 'team',
  '/billing': 'card',
  '/products': 'box',
  '/orders': 'box',
  '/bookings': 'calendar',
  '/admin': 'shield',
  '/admin/ai': 'sliders',
  '/reseller': 'card',
}
